module.exports = __webpack_public_path__ + "images/mdj/members/resume/mobile/common_btn_bg01-fbf45b6d2e7c65d57fe49f4dd1fd1673.png";